import styled from 'styled-components';
export var StyledContainer = styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-1ydvq01-0"
})(["border-radius:12px;background:#f8faff;"]);
export var StyledMainContainer = styled.div.withConfig({
  displayName: "StyledMainContainer",
  componentId: "sc-1ydvq01-1"
})(["display:flex;flex-flow:column nowrap;gap:8px;padding:16px 12px;"]);
export var StyledTitle = styled.div.withConfig({
  displayName: "StyledTitle",
  componentId: "sc-1ydvq01-2"
})(["color:#8d93b5;font-size:12px;font-weight:500;line-height:16px;"]);
export var StyledRateInfoWrapper = styled.div.withConfig({
  displayName: "StyledRateInfoWrapper",
  componentId: "sc-1ydvq01-3"
})(["display:flex;flex-flow:column nowrap;border-radius:12px;border:1px solid #ceceeb;padding:8px 12px;"]);
export var StyledTriggerPrice = styled.span.withConfig({
  displayName: "StyledTriggerPrice",
  componentId: "sc-1ydvq01-4"
})(["color:#5f4dbc;font-weight:700;"]);
export var StyledRateInfoText = styled.div.withConfig({
  displayName: "StyledRateInfoText",
  componentId: "sc-1ydvq01-5"
})(["font-size:12px;font-weight:500;line-height:200%;color:#5f4dbc;"]);
export var StyledOrderInfoWrapper = styled.ul.withConfig({
  displayName: "StyledOrderInfoWrapper",
  componentId: "sc-1ydvq01-6"
})(["margin:0;padding-inline-start:24px;list-style:disc;color:#5a5d6d;font-size:14px;font-weight:400;line-height:180%;"]);
export var StyledWarningInfoWrapper = styled.div.withConfig({
  displayName: "StyledWarningInfoWrapper",
  componentId: "sc-1ydvq01-7"
})(["padding:16px;border-radius:0px 0px 12px 12px;border-top:1px solid rgba(231,91,85,0.25);background:#fdefef;color:#fd5939;font-size:14px;font-weight:400;line-height:24px;"]);
export var StyledWarningUl = styled.ul.withConfig({
  displayName: "StyledWarningUl",
  componentId: "sc-1ydvq01-8"
})(["margin:0;padding-inline-start:24px;list-style:disc;"]);